import LoginForm from "../components/user/LoginForm";

function Login() {
  return (
    <div className="page p-1">
      <LoginForm />
    </div>
  );
}

export default Login;
